import React, { Component } from 'react';
import {
    Link
} from 'react-router-dom';

class TopicItem extends Component {
    render() {
        return (
            <Link to={this.props.link}>{this.props.title}</Link>
        );
    }
}

export default TopicItem;



// WEBPACK FOOTER //
// ./src/reference/ui/TopicItem.js